import React from "react";
import {
    Box,
    createStyles,
    TableBody,
    TableCell,
    TableRow,
    withStyles,
} from "@material-ui/core";
import { Row } from "./types";
import classes from "./noteRow.module.scss";
import iconDownload from "../../../assets/images/icon_download.png"

const StyledTableRow = withStyles(() =>
    createStyles({
        root: {
            // "&:nth-of-type(odd)": {
            //     backgroundColor: `#EEEEEE`,
            // },
        },
    })
)(TableRow);

export const TableDataColumns = (row: Row, key: number): JSX.Element => {

    return (
        <StyledTableRow hover key={`` + key}>
            <TableCell align="left"
                style={{
                    width: `400px`,
                    fontSize: `18px`,
                    fontFamily: `Noto Sans`,
                }}>
                {`${row.title}` || ""}
            </TableCell>
            <TableCell
                align="left"
                style={{
                    fontSize: `18px`,
                    fontFamily: `Noto Sans`,
                }}>
                {row.title ? (
                    <Box display="flex" alignItems="left" justifyContent="left">
                        <a
                            href={row.link}
                            className={classes.downloadLink}
                        >
                            <Box display="flex" alignItems="center" justifyContent="center">
                                <span className={`DownloadLetter ${row.code}`}>
                                  Tải về 
                                  <img
                                    className={`DownloadLetter ${row.code}`} 
                                    alt="img" 
                                    style={{ paddingLeft: '5px', height: '18px', width: '18px' }} 
                                    src={iconDownload}>
                                  </img>
                                </span>
                            </Box>
                        </a>
                    </Box>
                ) : (
                    ``
                )}
            </TableCell>
        </StyledTableRow>
    );
};

export const TableDataMobile = (row: Row): JSX.Element => {
    return (
        <TableBody>
            <TableRow>
                <TableCell style={{
                    width: `400px`,
                    fontSize: `18px`,
                    fontFamily: `Noto Sans`,
                    fontWeight: `bold`
                }}>{row.title}</TableCell>
                <TableCell
                    style={{
                        fontSize: `18px`,
                        fontFamily: `Noto Sans`
                    }}>
                    {row.title ? (
                        <Box display="flex" alignItems="center">
                            <a
                                href={row.link}
                                className={classes.downloadLink}
                            >
                                <Box display="flex" alignItems="center" justifyContent="center">
                                  <span className={`DownloadLetter ${row.code}`}>
                                    Tải về 
                                    <img
                                      className={`DownloadLetter ${row.code}`} 
                                      alt="img" 
                                      style={{ paddingLeft: '5px', height: '18px', width: '18px' }} 
                                      src={iconDownload}>
                                    </img>
                                  </span>
                                </Box>
                            </a>
                        </Box>
                    ) : (
                        ``
                    )}
                </TableCell>
            </TableRow>
        </TableBody>
    );
};
